import {inputType} from '../../../esgManager/interface/inputType';

export const SUSTENABILITY_FIELD_NAMES = {
  SUS_Q1_VALUE: 'susQ1_value',
  SUS_Q1_COMMENT: 'susQ1_comment',
  SUS_Q2_VALUE: 'susQ2_value',
  SUS_Q3_VALUE: 'susQ3_value',
  SUS_Q3_COMMENT: 'susQ3_comment',
  SUS_Q4_VALUE: 'susQ4_value'
} as const;


export const SustanabilityQuestions = {
  Group1: {
    fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q1_VALUE,
    question:
      'What motivates your organization to take action on reducing its carbon footprint?',
    fieldType: inputType.RADIOGROUP,
    Options: [
      {
        value: 'Regulatory compliance and ESG reporting requirements',
        label: 'Regulatory compliance and ESG reporting requirements'
      },
      {
        value: 'Reducing operational costs (e.g., energy efficiency)',
        label: 'Reducing operational costs (e.g., energy efficiency)'
      },
      {
        value: 'Corporate responsibility and contributing to a sustainable future',
        label:
          'Corporate responsibility and contributing to a sustainable future'
      },
      {
        value: 'Enhancing brand reputation and attracting socially-conscious investors',
        label:
          'Enhancing brand reputation and attracting socially-conscious investors'
      },
      {
        value: 'Market demand and consumer preference for sustainable products',
        label: 'Market demand and consumer preference for sustainable products'
      },
      {
        value: 'Other',
        label: 'Other (please specify)'
      }
    ],
    Comment: {
      fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q1_COMMENT,
      fieldType: inputType.TEXTAREA,
      QUESTION: ''
    }
  },
  Group2: {
    fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q2_VALUE,
    question:
      'How important is it for your company to meet sustainability goals and ESG standards?',
    fieldType: inputType.RADIOGROUP,
    Options: [
      {
        value: 'Extremely important – It’s a core part of our business strategy',
        label: 'Extremely important – It’s a core part of our business strategy'
      },
      {
        value: 'Very important – We are committed but still aligning our efforts',
        label:
          'Very important – We are committed but still aligning our efforts'
      },
      {
        value: 'Somewhat important – We meet the minimum requirements but are looking to improve',
        label:
          'Somewhat important – We meet the minimum requirements but are looking to improve'
      },
      {
        value: 'Not very important – Sustainability and ESG are not a top priority',
        label:
          'Not very important – Sustainability and ESG are not a top priority'
      },
      {
        value: 'Not at all important – We don’t focus on sustainability or ESG standards',
        label:
          'Not at all important – We don’t focus on sustainability or ESG standards'
      }
    ]
  },

  Group3: {
    fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q3_VALUE,
    question: 'Choose Your Sustainability Goals',
    fieldType: inputType.RADIOGROUP,
    Options: [
      {
        value: 'Reduce energy consumption and transition to renewable sources',
        label: 'Reduce energy consumption and transition to renewable sources'
      },
      {
        value: 'Ensure sustainable sourcing and ethical supply chain practices',
        label: 'Ensure sustainable sourcing and ethical supply chain practices'
      },
      {
        value: 'Enhance product lifecycle sustainability',
        label: 'Enhance product lifecycle sustainability'
      },
      {
        value: 'Attract sustainable investment through improved ESG practices',
        label: 'Attract sustainable investment through improved ESG practices'
      },
      {
        value: 'Enhance stakeholder trust and loyalty through sustainability efforts',
        label:
          'Enhance stakeholder trust and loyalty through sustainability efforts'
      },
      {
        value: 'Other',
        label: 'Other (please specify)'
      }
    ],
    Comment: {
      fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q3_COMMENT,
      fieldType: inputType.TEXTAREA,
      QUESTION: ''
    }
  },
  Group4: {
    fieldName: SUSTENABILITY_FIELD_NAMES.SUS_Q4_VALUE,
    question:
      `How would you rate your organization’s current level of awareness and 
      understanding of carbon accounting and ESG compliance?`,
    fieldType: inputType.RADIOGROUP,
    Options: [
      {
        value: 'Highly aware and knowledgeable',
        label: 'Highly aware and knowledgeable'
      },
      {
        value: 'Moderately aware',
        label: 'Moderately aware'
      },
      {
        value: 'Basic awareness',
        label: 'Basic awareness'
      },
      {
        value: 'Minimal awareness',
        label: 'Minimal awareness'
      },
      {
        value: 'No awareness',
        label: 'No awareness'
      }
    ]
  }
};
